import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  name: 'SelectMangerMemberRechargeDetailedList',
  data: function data() {
    return {
      isSelect: this.checkauthority('SelectManger_member_recharge_detailed_select'),
      isExport: this.checkauthority('SelectManger_member_recharge_detailed_export'),
      selectForm: {
        userName: '',
        name: '',
        createTimes: [],
        selectCity: [],
        memberNoOrPhone: null,
        areType: null,
        rechargeType: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      citys: []
    };
  },
  methods: {
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: 1000000000,
        memberNoOrPhone: this.selectForm.memberNoOrPhone,
        areType: this.selectForm.areType,
        rechargeType: this.selectForm.rechargeType
      };
      if (this.selectForm.createTimes.length > 1) {
        par.startTime = this.selectForm.createTimes[0];
        par.endTime = this.selectForm.createTimes[1];
      }
      if (this.selectForm.selectCity.length > 1) {
        par.selectCity = this.selectForm.selectCity;
      }
      var url = 'admin/v1/statistics/memberRechargeDetailedExport';
      this.downloadUtil.excelExport(url, par, '充值记录.xls');
    },
    reset: function reset() {
      this.selectForm.createTimes = [];
      this.selectForm.selectCity = [];
      this.selectForm.memberNoOrPhone = null;
      this.selectForm.areType = null;
      this.selectForm.rechargeType = null;
      this.tableData = [];
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(_this.selectForm.memberNoOrPhone === '' || _this.selectForm.memberNoOrPhone === null)) {
                _context.n = 1;
                break;
              }
              _this.$message.error('请输入ID号或手机号');
              return _context.a(2);
            case 1:
              par = {
                pageNo: _this.pageNo,
                pageSize: _this.pageSize,
                memberNoOrPhone: _this.selectForm.memberNoOrPhone,
                areType: _this.selectForm.areType,
                rechargeType: _this.selectForm.rechargeType
              };
              if (_this.selectForm.createTimes.length > 1) {
                par.startTime = _this.selectForm.createTimes[0];
                par.endTime = _this.selectForm.createTimes[1];
              }
              if (_this.selectForm.selectCity.length > 1) {
                par.selectCity = _this.selectForm.selectCity;
              }
              _context.n = 2;
              return api.GET_MEMBER_RECHARGE_DETAILED_LIST_PAGE_LIST(par);
            case 2:
              res = _context.v;
              _this.tableData = res.body.datas;
              _this.pageTotal = res.body.sumDataCount;
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    initCitys: function initCitys() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context2.v;
              _this2.citys = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initCitys();
  }
};